import { inject, Signal } from '@angular/core';
import { CanMatchFn, Route, UrlSegment } from '@angular/router';
import { IS_B2B } from '@lentau/profile/organizations/legal-entity/shared/tokens/is-b2b-profile.token';
import { GrowthBookService } from '@lentau/core/growth-book/shared';
import { pwaB2cCheckoutExperiment } from '../experiments/pwa-b2c-checkout.experiment';

export const canMatchPwaB2cCheckout: CanMatchFn = (_route: Route, segments: UrlSegment[]): boolean => {
  const isB2B: Signal<boolean> = inject(IS_B2B);
  const pwaCheckoutEnabled: Signal<boolean> = pwaB2cCheckoutExperiment();
  const growthBookService: GrowthBookService = inject(GrowthBookService);
  const path0: string | undefined = segments[0]?.path;
  const path1: string | undefined = segments[1]?.path;
  const pathMatch: boolean = path0 === 'ordering' && path1 === 'interval';
  const isExperimentPending: boolean = !growthBookService.isInitialized();

  return !isB2B() && pathMatch && (isExperimentPending || pwaCheckoutEnabled());
};
